var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-card', {
    staticClass: "card-custom-class"
  }, [_c('div', {
    staticClass: "closemodel"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        _vm.$bvModal.hide('bv-write-review');
        _vm.reset();
      }
    }
  }, [_c('span', [_c('img', {
    attrs: {
      "src": "img/address/close.png",
      "alt": ""
    }
  })])])]), _c('span', {
    staticClass: "change-location-text"
  }, [_vm._v(_vm._s(_vm.$t("myOrder.writeReview")))])]), _c('b-card', [_c('div', {
    staticClass: "p-4"
  }, [_c('ValidationObserver', {
    ref: "observer",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var _vm$orderDetails, _vm$orderDetails$deli;
        var invalid = _ref.invalid;
        return [_c('b-row', {
          staticClass: "shadow-sm rounded p-3 mb-4 align-items-center bg-white"
        }, [_c('b-col', {
          staticClass: "text-center",
          attrs: {
            "cols": "2"
          }
        }, [_c('b-img', {
          staticClass: "product-image",
          attrs: {
            "src": _vm.item && _vm.item.imageLink ? _vm.item.imageLink : 'https://via.placeholder.com/100',
            "fluid": "",
            "rounded": "circle"
          }
        })], 1), _c('b-col', {
          attrs: {
            "cols": "10"
          }
        }, [_c('b-row', [_c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('p', {
          staticClass: "font-14"
        }, [_c('strong', [_vm._v("Order Id :")]), _vm._v(" " + _vm._s(_vm.orderDetails.orderId) + " ")]), _c('p', {
          staticClass: "font-14"
        }, [_c('strong', [_vm._v("Order Delivered Date :")]), _vm._v(" 21-05-2025 ")])]), _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('p', {
          staticClass: "font-14"
        }, [_c('strong', [_vm._v("Item Name :")]), _vm._v(" " + _vm._s(_vm.item.name) + " ")]), _c('p', {
          staticClass: "font-14"
        }, [_c('strong', [_vm._v("Delivered By :")]), _vm._v(" " + _vm._s(((_vm$orderDetails = _vm.orderDetails) === null || _vm$orderDetails === void 0 ? void 0 : (_vm$orderDetails$deli = _vm$orderDetails.deliveryAgent) === null || _vm$orderDetails$deli === void 0 ? void 0 : _vm$orderDetails$deli.name) || "N/A") + " ")])])], 1)], 1)], 1), _c('div', {
          staticClass: "text-center mb-2"
        }, [_c('h5', [_c('strong', [_vm._v("How was your delivery?")])]), _c('p', {
          staticClass: "text-muted"
        }, [_vm._v("Please enter your rate experience")])]), _c('b-row', {
          staticClass: "justify-content-center mb-3"
        }, [_c('div', {
          staticClass: "text-center"
        }, [_c('div', {
          staticClass: "star-rating d-flex"
        }, _vm._l(5, function (i) {
          return _c('b-icon', {
            key: i,
            staticClass: "mx-1 pointer",
            attrs: {
              "icon": i <= _vm.rating ? 'star-fill' : 'star',
              "variant": "warning",
              "font-scale": "2"
            },
            on: {
              "click": function ($event) {
                _vm.rating = i;
              }
            }
          });
        }), 1), _vm.ratingText ? _c('p', {
          staticClass: "mt-2 mb-0 font-smallfont-"
        }, [_vm._v(" " + _vm._s(_vm.ratingText) + " ")]) : _vm._e()])]), _c('b-row', {
          staticClass: "mb-3"
        }, [_c('b-col', {
          attrs: {
            "md": "5"
          }
        }, [_c('label', {
          staticClass: "d-block mb-2 font-weight-bold"
        }, [_vm._v("Comment")]), _c('ValidationProvider', {
          attrs: {
            "rules": "required",
            "name": _vm.$t('myOrder.Enteryourcomment')
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref2) {
              var errors = _ref2.errors;
              return [_c('b-form-textarea', {
                staticClass: "w-100",
                attrs: {
                  "placeholder": _vm.$t('myOrder.Enteryourcomment'),
                  "rows": "4"
                },
                model: {
                  value: _vm.reviewComment,
                  callback: function ($$v) {
                    _vm.reviewComment = $$v;
                  },
                  expression: "reviewComment"
                }
              }), _c('span', {
                staticClass: "validate-error"
              }, [_vm._v(_vm._s(errors[0]))])];
            }
          }], null, true)
        })], 1), _c('b-col', {
          attrs: {
            "md": "7"
          }
        }, [_c('label', {
          staticClass: "d-block mb-2 font-weight-bold"
        }, [_vm._v(" Add Photos Or Videos (Optional) ")]), _c('b-row', [_c('b-col', {
          attrs: {
            "md": "3"
          }
        }, [_c('div', {
          staticClass: "upload-box-main add-box border rounded text-center d-flex flex-column justify-content-center align-items-center mb-2",
          on: {
            "click": _vm.triggerFileInput
          }
        }, [_c('b-icon', {
          staticClass: "mb-2",
          attrs: {
            "icon": "camera",
            "font-scale": "1.5"
          }
        }), _c('span', {
          staticClass: "small text-muted"
        }, [_vm._v("Add photos or Videos")])], 1)]), _c('b-col', {
          staticClass: "pl-0",
          attrs: {
            "md": "9"
          }
        }, [_c('div', {
          staticClass: "media-list-wrapper"
        }, [_c('div', {
          staticClass: "media-scroll d-flex flex-wrap"
        }, _vm._l(_vm.mediaFiles, function (item, index) {
          return _c('div', {
            key: 'media-' + index,
            staticClass: "upload-box media-item border rounded text-center position-relative m-2"
          }, [_vm.isImage(item) ? _c('img', {
            staticClass: "img-preview",
            attrs: {
              "src": item.preview
            }
          }) : _c('b-icon', {
            staticClass: "text-muted",
            attrs: {
              "icon": "file-earmark-play",
              "font-scale": "2"
            }
          }), _c('b-icon', {
            staticClass: "remove-icon",
            attrs: {
              "icon": "x-circle-fill",
              "variant": "danger"
            },
            on: {
              "click": function ($event) {
                $event.stopPropagation();
                return _vm.removeFile(index, item.url);
              }
            }
          })], 1);
        }), 0)])])], 1), _c('input', {
          ref: "fileInput",
          staticClass: "d-none",
          attrs: {
            "type": "file",
            "accept": "image/*,video/*",
            "multiple": ""
          },
          on: {
            "change": _vm.handleFileUpload
          }
        })], 1)], 1), _c('h5', {
          staticClass: "font-weight-medium mb-4"
        }, [_vm._v("What went well?")]), _c('b-row', {
          staticClass: "mb-4"
        }, _vm._l(_vm.tags, function (item, index) {
          return _c('b-col', {
            key: index,
            staticClass: "mb-3 pt-0 pb-0",
            attrs: {
              "md": "4",
              "sm": "6",
              "cols": "12"
            }
          }, [_c('b-form-checkbox', {
            staticClass: "pill-button w-100",
            class: {
              active: _vm.selectedTags.includes(item)
            },
            attrs: {
              "value": item,
              "button": "",
              "button-variant": "outline-primary"
            },
            model: {
              value: _vm.selectedTags,
              callback: function ($$v) {
                _vm.selectedTags = $$v;
              },
              expression: "selectedTags"
            }
          }, [_vm._v(" " + _vm._s(item) + " ")])], 1);
        }), 1), _c('b-row', {
          staticClass: "mt-0"
        }, [_c('b-col', {
          staticClass: "text-center",
          attrs: {
            "md": "12"
          }
        }, [_c('p', {
          staticStyle: {
            "display": "none"
          }
        }, [_vm._v(_vm._s(invalid))]), _c('b-button', {
          staticClass: "px-5",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.onClickSubmit
          }
        }, [_vm._v(_vm._s(_vm.$t("myOrder.submit")))])], 1)], 1)];
      }
    }])
  })], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }